// <auto-generated />
// ATENCAO: Arquivo auto-gerado pelo SetupController. Nao altere manualmente.

export const FIN_FINANCIAMENTO_DEMANDA_ST = {
  AguardandoCriacao: 'FIN_FINANCIAMENTO_DEMANDA_ST1',
  RascunhoAFormalizar: 'FIN_FINANCIAMENTO_DEMANDA_ST2',
  AguardandoFaturamento: 'FIN_FINANCIAMENTO_DEMANDA_ST3',
  TitulosSemVinculo: 'FIN_FINANCIAMENTO_DEMANDA_ST4',
  EmAndamento: 'FIN_FINANCIAMENTO_DEMANDA_ST5',
  // Mapa de sequencia (SequenciaLista) para lookup por codigo
  sequencia: {
    FIN_FINANCIAMENTO_DEMANDA_ST1: 1,
    FIN_FINANCIAMENTO_DEMANDA_ST2: 2,
    FIN_FINANCIAMENTO_DEMANDA_ST3: 3,
    FIN_FINANCIAMENTO_DEMANDA_ST4: 4,
    FIN_FINANCIAMENTO_DEMANDA_ST5: 5
  }
}
